import { Device } from '@capacitor/device';

/**
 * Der Ladestand in Prozent, wie ihn der Classic-Herzschlag erwartet (`batteryStatus`).
 *
 * `@capacitor/device` liefert `batteryLevel` als Anteil zwischen 0 und 1 — und im Browser gar
 * nichts, weil die Battery Status API dort abgeschafft ist. **Der Rückfall ist 100**, nicht 0:
 * ein gemeldeter Ladestand von null brächte die Management-Konsole des Prüfungsleiters dazu,
 * ein Gerät als gleich ausfallend anzuzeigen, das in Wahrheit nur im Browser läuft.
 */
export async function ladestand(): Promise<number> {
  try {
    const info = await Device.getBatteryInfo();
    if (typeof info.batteryLevel !== 'number' || !Number.isFinite(info.batteryLevel)) return 100;
    return Math.max(0, Math.min(100, Math.round(info.batteryLevel * 100)));
  } catch {
    return 100;
  }
}

/**
 * Wie die alte Classic-App: `1000` heisst „am Strom“, sonst der Ladestand in Prozent
 * (`docs/classic-rest-api.md` §3).
 */
export async function ladestandClassic(): Promise<number> {
  try {
    const info = await Device.getBatteryInfo();
    if (info.isCharging === true) return 1000;
  } catch {
    // Kein Ladezustand bekannt — dann eben nur der Stand.
  }
  return ladestand();
}
